module.exports = __webpack_public_path__ + "img/indeximg4.4bd51322.png";